import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import VisibilitySensor from "react-visibility-sensor";

import img1 from "../../../assets/img/warehouseStructure/warehouseFour/warehouseFour.webp";
import seta from "../../../assets/img/components/seta2.webp";

function WarehouseFour(){

    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    const onChange = (visibility) => {
      if (visibility) {
        setIsVisible(true);
      }
    };

    return(
        <VisibilitySensor onChange={onChange} partialVisibility minTopValue={100}>
            <div>
              <h1 className={`warehouseTitle ${isVisible ? 'visible' : ''}`}>{t("warehouse_four_super_title")} <span>{t("warehouse_four_super_title_span")}</span></h1>
              <div className="warehouseFour">
                <h1 className={`${isVisible ? 'visible' : ''}`}>{t("warehouse_four_title")}</h1>
                <p className={`${isVisible ? 'visible' : ''}`}>
                  {t("warehouse_four_text")}
                </p>
                <ul className={`${isVisible ? 'visible' : ''}`}>
                  <li><img src={seta} className="seta" alt=""/> {t("warehouse_four_li1")}</li>
                  <li><img src={seta} className="seta" alt=""/> {t("warehouse_four_li2")}</li>
                  <li><img src={seta} className="seta" alt=""/> {t("warehouse_four_li3")}</li>
                  <li><img src={seta} className="seta" alt=""/> {t("warehouse_four_li4")}</li>
                  <li><img src={seta} className="seta" alt=""/> {t("warehouse_four_li5")}</li>
                  <li><img src={seta} className="seta" alt=""/> {t("warehouse_four_li6")}</li>
                  <li><img src={seta} className="seta" alt=""/> {t("warehouse_four_li7")}</li>
                </ul>
                <img className={`${isVisible ? 'visible' : ''}`} src={img1} alt="" width={'200px'}/>
              </div>
          </div>
        </VisibilitySensor>
    )
}
export default WarehouseFour;